import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

import MobileLayout from './components/SecondSection/MobileStylistLayout.jsx';
import TabletLayout from './components/SecondSection/TabletStylistLayout.jsx';
import DesktopLayout from './components/SecondSection/DesktopStylistLayout.jsx';

import HairstylistData from '../AboutUs/Data/HairstylistData';

function SecondSection() {
  const [scrollPosition, setScrollPosition] = useState(0);

  const [deviceType, setDeviceType] = useState('desktop');
    
    useEffect(() => {
      const handleResize = () => {
        const width = window.innerWidth;
        if (width < 768) {
          setDeviceType('mobile');
        } else if (width < 1024) {
          setDeviceType('tablet');
        } else {
          setDeviceType('desktop');
        }
      };
      
      handleResize();
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

  const scroll = (direction) => {
    const container = document.getElementById('stylist-container');
    const scrollAmount = 300;
    if (container) {
      if (direction === 'left') {
        container.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth'
        });
        setScrollPosition(Math.max(0, scrollPosition - scrollAmount));
      } else {
        container.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
        setScrollPosition(scrollPosition + scrollAmount);
      }
    }
  };

  return (
    <div className="min-h-screen">
      <main className="max-w-7xl mx-auto px-4 py-12">
        {/* Previous sections remain the same */}
        
        {/* New Stylist Slider Section */}
        <div className="min-h-max py-12 px-4 relative">
          <div className="max-w-7xl mx-auto">
            {/* Header */}
            <div className="mb-12 space-y-2">
              <h2 className="text-gray-400 text-lg uppercase tracking-widest">PROFILE</h2>
              <h1 className="text-4xl font-bold uppercase text-neutral-800">
                Tim Profesional Kami
              </h1>
            </div>

            {deviceType === 'mobile' && <MobileLayout stylists={HairstylistData} />}
            {deviceType === 'tablet' && <TabletLayout stylists={HairstylistData} />}
            {deviceType === 'desktop' && <DesktopLayout stylists={HairstylistData} />}
          </div>
        </div>

        {/* Facilities Section */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-8 text-neutral-800">Fasilitas Kami</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {['Ruang AC', 'Wifi Gratis', 'Minuman Gratis', 'Parkir Luas'].map((facility, index) => (
              <div key={index} className="bg-white p-4 rounded-lg shadow-sm text-center border border-neutral-100">
                <p className="font-medium text-neutral-700">{facility}</p>
              </div>
            ))}
          </div>
        </section>

        {/* CTA Section */}
        <section className="text-center bg-amber-50 rounded-xl p-8 border border-amber-100">
          <h2 className="text-3xl font-bold mb-4 text-neutral-800">Siap Untuk Tampil Berbeda?</h2>
          <p className="text-neutral-600 mb-6">
            Booking appointment sekarang dan dapatkan pengalaman styling rambut terbaik
          </p>
          <button className="bg-amber-800 text-white px-8 py-3 rounded-full font-medium hover:bg-amber-900 transition-colors">
            Book Appointment
          </button>
        </section>
      </main>
    </div>
  )
}

export default SecondSection